import {
  Injectable,
  Injector,
  InjectionToken,
  Type,
  AbstractType,
} from '@angular/core';
import { each, forEach, isArray, isFunction, set } from 'lodash';
import { IQohInventoryItemVenue } from '@app/shared/types';

@Injectable()
export class TransferQtyService {
  public constructor(public injector: Injector) {}

  public clearField(
    fieldPath: string[],
    sourceData: IQohInventoryItemVenue[],
  ): IQohInventoryItemVenue[] {
    return each(sourceData, (item) => {
      forEach(isArray(fieldPath) ? fieldPath : [fieldPath], (key) => {
        set(item, key, null);
      });

      return item;
    });
  }

  public inject<T>(
    token: Type<T> | InjectionToken<T> | AbstractType<T>,
    notFoundValue?: T,
  ): T {
    if (isFunction(this.injector.get)) {
      return this.injector?.get(token, notFoundValue);
    }

    return notFoundValue;
  }
}
